import React from "react";
import { Dayjs } from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { JOINED_MONTH_MIN_DATE, joinedMonthMaxDate } from "./joinedMonth";

interface Props {
  value: Dayjs | null;
  onChange: (value: Dayjs | null) => void;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}

/**
 * Month + year picker for the student "Joined Month" field. Opens straight to
 * the 12-month grid (not the year list), lets the user step between years, and
 * is bounded to [2010, this month] so unreasonable / future values (e.g. 2056)
 * can't be picked. Displays "July 2026"; the caller stores "YYYY-MM" via
 * formatJoinedMonthForApi. Used by both Create and Edit Student.
 */
const JoinedMonthPicker: React.FC<Props> = ({ value, onChange, error, helperText, disabled }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      views={["year", "month"]}
      openTo="month"
      format="MMMM YYYY"
      minDate={JOINED_MONTH_MIN_DATE}
      maxDate={joinedMonthMaxDate()}
      value={value}
      onChange={onChange}
      disabled={disabled}
      slotProps={{
        textField: {
          size: "small",
          fullWidth: true,
          placeholder: "Select joined month",
          error,
          helperText,
        },
        // Clearing the field is allowed (Joined Month is optional).
        field: { clearable: true, onClear: () => onChange(null) },
      }}
    />
  </LocalizationProvider>
);

export default JoinedMonthPicker;
